import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { PER_PAGE } from "contexts/OutreachContacts";
import { OutreachContactsContext } from "contexts/OutreachContacts";
import { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import ScheduledSidebar from "./ScheduledSidebar";
import ScheduledThreadPreview from "./ScheduledThreadPreview";
import ScheduledMobileThreadPreview from "./ScheduledThreadPreview/mobile";
import ScheduledSkeleton from "./skeleton";
import styles from "./styles";

interface Props {
  isSmallScreen: boolean;
  sidebarOpen: boolean;
}

const Scheduled = ({ isSmallScreen, sidebarOpen }: Props) => {
  const { fetchLoading, total } = useContext(OutreachContactsContext);

  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      sx={isSmallScreen ? styles.mobileRoot : styles.root(isMediumScreen)}
    >
      <Grid
        item
        xs={12}
        md={isSmallScreen ? 12 : 3.5}
        sx={isSmallScreen ? {} : styles.sidebarContainer}
      >
        {fetchLoading ? (
          <ScheduledSkeleton />
        ) : (
          <ScheduledSidebar
            totalPages={Math.ceil((total || 0) / PER_PAGE)}
            isSmallScreen={isSmallScreen}
            sidebarOpen={sidebarOpen}
          />
        )}
      </Grid>

      <Routes>
        <Route
          path=":outreachContactId/*"
          element={
            isSmallScreen ? (
              <ScheduledMobileThreadPreview />
            ) : (
              <Grid item xs sx={styles.mainThreadContainer}>
                <ScheduledThreadPreview />
              </Grid>
            )
          }
        >
          <Route
            path="email/:threadId"
            element={
              <Grid item xs sx={styles.mainThreadContainer}>
                <ScheduledThreadPreview />
              </Grid>
            }
          />
        </Route>
      </Routes>
    </Grid>
  );
};

export default Scheduled;
